module.exports = __webpack_public_path__ + "img/signature_background_mobile@2x.6db5fd7.jpg";